/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface BillForUsageFee
 */
export interface BillForUsageFee {
    /**
     * 
     * @type {string}
     * @memberof BillForUsageFee
     */
    'billId': string;
    /**
     * 
     * @type {string}
     * @memberof BillForUsageFee
     */
    'bankAccountActivityId': string;
    /**
     * 
     * @type {string}
     * @memberof BillForUsageFee
     */
    'supplierName': string;
    /**
     * 
     * @type {string}
     * @memberof BillForUsageFee
     */
    'latestStatus': BillForUsageFeeLatestStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof BillForUsageFee
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof BillForUsageFee
     */
    'appliedAt': string;
    /**
     * 
     * @type {string}
     * @memberof BillForUsageFee
     */
    'transferDate': string;
}

export const BillForUsageFeeLatestStatusEnum = {
    reserved: 'RESERVED',
    requestingExternalAccountTransfer: 'REQUESTING_EXTERNAL_ACCOUNT_TRANSFER',
    completed: 'COMPLETED',
    insufficientBalance: 'INSUFFICIENT_BALANCE',
    uploaded: 'UPLOADED',
    readCompleted: 'READ_COMPLETED',
    awaitingApproval: 'AWAITING_APPROVAL',
    approved: 'APPROVED',
    transferCompleted: 'TRANSFER_COMPLETED',
    readError: 'READ_ERROR',
    transferFailed: 'TRANSFER_FAILED',
    approvalExpired: 'APPROVAL_EXPIRED',
    approvalRejected: 'APPROVAL_REJECTED',
    otherError: 'OTHER_ERROR',
    pending: 'PENDING'
} as const;

export type BillForUsageFeeLatestStatusEnum = typeof BillForUsageFeeLatestStatusEnum[keyof typeof BillForUsageFeeLatestStatusEnum];


